module.exports = __webpack_public_path__ + "static/media/sir-foundalot.8e82204c.png";